import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { of } from 'rxjs';

import { EASLinkAction } from '@fry/components/common/buttons/buttons.service';
import { SecurityService } from '@fry/lib/security';
import { Venue } from '@fry/booking/lib/venues';
import { LanguageService } from '@fry/lib/organisations/language.service';

@Component({
    selector: 'eas-venue-slot',
    templateUrl: './venue-slot.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VenueSlotComponent implements OnInit {
  @Input() venue: Venue;

  public buttons: EASLinkAction[];

  constructor(
    private security: SecurityService,
    private language: LanguageService,
  ) { }

  ngOnInit() {
    this.buttons = this.getButtons();
  }

  getButtons(): EASLinkAction[] {
    const originalLanguageCode = this.language.getOriginalLanguageCode();
    const translationLanguageCodes = this.language.getTranslationLanguageCodes();

    const translateButtons: EASLinkAction[] = translationLanguageCodes.map(translationLanguageCode => ({
      type: 'link',
      label: $localize `Edit translation (${translationLanguageCode})`,
      condition: () => {
        return this.security.hasPermission('translations.view');
      },
      link: of(['/', 'translation', this.venue.doc.type, this.venue.doc._id, translationLanguageCode])
    }));

    return [
      {
        type: 'link',
        label: translationLanguageCodes.length === 0 ? $localize `Edit` : $localize `Edit original (${originalLanguageCode})` ,
        condition: () => {
          return of(true);
        },
        link: of([this.venue.doc._id, 'edit'])
      },
      ...translateButtons
    ];
  }

  getDefaultTitle() {
    return $localize `No name`;
  }
}
